// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {bd_countries} from 'hola_opt';
import country_utils from '/util/country.js';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import Icon_google from '../../img/icons/24/color/google.svg';
import {perr} from 'hola_pub_util';
import Icon_trustpilot from '../../../../toolip/pub/img/trustpilot_micro.svg';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Button} from '../../lib/button';
import {use_login} from '../navbar/use_login';
import {Map} from '../../../../toolip/pub/ui/landings/map';
import anim_styles from '../../../../toolip/pub/ui/animation.module.less';
import {Flag} from '../common/flag';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import Svg_bg_left from '../../img/homepage/hero_left.svg';
import Svg_bg_right from '../../img/homepage/hero_right.svg';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './hero.module.less';

interface i_hero_props {
  country: string;
  region: string;
}

const region_name_map = {
  'North-America': 'Northern America',
  'Latin-America': 'South America',
};

export const Hero = (props: i_hero_props)=>{
    const {country, region} = props;
    const {width} = use_screen();
    const {theme} = useContext(Settings_context);
    const {on_login} = use_login(true, '/dashboard');
    const {user, show_free_zone_promo} = use_app_context();
    const detected_region = React.useMemo(()=>{
        return region
            ? country_utils.get_location_info(region) : null;
    }, [region]);
    const is_us_region = detected_region?.type === 'region';
    const location_info = React.useMemo(()=>{
        if (is_us_region)
            return country_utils.get_location_info('united-states');
        return country_utils.get_location_info(country);
    }, [country, detected_region]);
    const mode = location_info?.type === 'country' || is_us_region
        ? 'country' : location_info?.type || 'landing';
    const name = location_info?.name;
    const code = is_us_region
        ? 'us' : location_info?.code === 'uk'
        ? 'gb' : location_info?.code;
    const flag_size = width > 1180 || width < 768 ? 45 : 60;
    const not_country_page = mode !== 'country';
    const cta_text = show_free_zone_promo ? 'Try now for free' : 'Try now';
    const hero_data = React.useMemo(()=>{
        switch (mode)
        {
            case 'continent': {
                const region_key = region_name_map[name] || name;
                const continent_ip_count = bd_countries
                    .by_region[region_key]?.count || 0;
                return {
                    name,
                    ip_count: continent_ip_count
                };
            }
            case 'country':
            {
                const country_ip_count = bd_countries
                    && bd_countries[code] || 0;
                return {
                    name: is_us_region
                        ? detected_region.name
                        : name,
                    country_code: code,
                    ip_count: country_ip_count
                };
            }
            default:
                return null;
        }
    }, [mode, name, code, detected_region]);
    const country_continent_subtitle = <>You can
      access any website of your choice
      from {hero_data?.name} with real residential IPs, ISPs, <br/>or
      datacenter proxies. Reach your target without being blocked
      and remain anonymous.</>;
    const title_subtitle_map = {
      landing: {
        title: 'Global Proxy Network',
        subtitle: <>
          Choose & connect to proxies from 50+ Countries. <br/>
          Proxies available in United States, France, Germany, UK,
          Netherlands and many more.
        </>
      },
      continent: {
        title: <>
          {hero_data?.ip_count?.toLocaleString()}
          <br/> {hero_data?.name} Proxies
        </>,
        subtitle: country_continent_subtitle
      },
      country: {
        title: <>
          <Flag country={hero_data?.country_code}
            cls={styles.flag} size={flag_size}/>
          {hero_data?.ip_count?.toLocaleString()}&nbsp;
          <p className={styles.flag_br}><br/></p>
          {' '}
          {hero_data?.name} Proxies
        </>,
        subtitle: country_continent_subtitle
      }
    };
    const title_by_mode = title_subtitle_map[mode]
        || title_subtitle_map['landing'];
    const render_title = title_by_mode.title || 'Proxy Network';
    const render_subtitle = title_by_mode.subtitle || '';
    return <div className={styles.hero_wrapper}>
      {mode !== 'country' &&
          <div className={styles.bg_blur}/>}
      <div className={styles.hero}>
        {mode=='country' && <div className={styles.hero_bg}>
          <Svg_bg_left className={styles.bg_left}/>
          <Svg_bg_right className={styles.bg_right}/>
          <div className={styles.bg_center}/>
        </div>}
          <div className={cn(theme.container, styles.container)}>
            <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
              <p className={cn(theme.mono14, styles.uptime)}>
                <Lottie autoplay loop width="20px" height="14px"
                  src={oculus_img_url('animation/uptime.json')}/>
                <span>Uptime: <b>99.9%</b></span>
              </p>
            </div>
            <div className={styles.hero_text_wrapper}>
              <h1 className={cn(styles.hero_title, anim_styles.hero_showup_2)}>
                {render_title}
              </h1>
              <p className={cn(theme.p16, theme.med, styles.sub_title,
                anim_styles.hero_showup_2)}>
                {render_subtitle}
              </p>
              <div className={cn(styles.hero_cta, anim_styles.hero_showup_3)}>
                <Button caption={<>{cta_text} <Icon_arrow_right/></>}
                  size={'l'} to={'/pricing'}
                  on_click={()=>{
                    perr({id: 'oculus_homepage_hero_cta_click'});
                  }}
                />
                {!user && <Button caption={<><Icon_google/> Sign in with Google</>}
                  size={'l'} color={'social'}
                  on_click={ev=>{
                    on_login(ev);
                    perr({id: 'oculus_homepage_signin_click'});
                  }}
                />}
              </div>
              <p className={cn(theme.p12, theme.med, styles.hero_cta_text,
                anim_styles.hero_showup_3)}>* No credit card needed. Free
                  plan available.</p>
              <a href="https://www.trustpilot.com/review/oculusproxies.com"
                target="_blank" rel="noopener noreferrer"
                className={cn(anim_styles.hero_showup_4, styles.trustpilot,
                  not_country_page && styles.alt_trustpilot)}>
                <Icon_trustpilot/>
              </a>
            </div>
          </div>
      </div>
      <div className={cn(styles.map_container, anim_styles.hero_showup_5,
        mode=='country' && styles.country)}>
        <Map shown_in_home={true}/>
      </div>
    </div>;
};
